import React from 'react';
import LookupVocabularyRow from './LookupVocabularyRow';

const LookupVocabularyTableRows = ({
  lookupItems,
  validationWarnings,
  canEdit,
  showWarning,
}) => (
  lookupItems.map((item) => (
    <LookupVocabularyRow
      key={`vocabulary_table_row_${item.uuid}`}
      lookupItemUUID={item.uuid}
      canEdit={canEdit}
      validationWarnings={validationWarnings}
      showWarning={showWarning}
    />
  ))
);

export default LookupVocabularyTableRows;
